import { TraceXInterceptor } from '@trace-x/trace-x-generator';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SurfTariffSearchService } from '../surf-tariff-search.service';
import { TariffSearchResultService } from '../services/tariff-search-result.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'surf-tariff-search',
  templateUrl: './surf-tariff-search.component.html',
})
export class SurfTariffSearchComponent implements OnInit {

  @Output() goBack = new EventEmitter<any>();

  resultList = [];

  constructor(
    private surfTariffSearchService: SurfTariffSearchService,
    public tariffSearchResultService: TariffSearchResultService,
  ) { }

  ngOnInit(): void {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/surf-tariff-search/surf-tariff-search.component.ts.SurfTariffSearchComponent.ngOnInit');
    this.surfTariffSearchService.getTariffHotelResults().subscribe((results) => {
      this.resultList = results;
    });
  }

  onGoBack() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-tariff-search/src/lib/surf-tariff-search/surf-tariff-search.component.ts.SurfTariffSearchComponent.onGoBack');
    this.goBack.emit();
  }
}
